import { observer } from 'mobx-react-lite'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Product, ProductsTable } from '../components/products/ProductsTable'
import { ExpandedPerformanceMetrics } from '../components/table2/ad_grid_columns'
import { TableStore } from '../components/table2/table_store'
import { useSavedFiltersStore } from '../hooks/useSavedFiltersStore'
import { useTableHooksFromStore } from '../packages/blueprint-components/src/useTableHooks'
import { State } from '../reducers'
import { userStore } from '../stores/user_store'
import type { Campaign, PerformanceMetrics } from '../types/campaign'
import type { EntityId } from '../types/constants'
import { adManagerPerformanceGet } from '../util/adManagerPerformanceApi'

export const Products = observer(() => {
    const profile = useSelector<State, EntityId | null>((state) => state.user.profile)

    const load = (params: any) => {
        if (!profile) {
            return Promise.resolve()
        }

        return adManagerPerformanceGet('api/v5/products', params, true)
    }
    const [store] = useState<TableStore<Product & ExpandedPerformanceMetrics>>(
        new TableStore<Campaign & PerformanceMetrics>(userStore, 'products'),
    )
    const savedFiltersStore = useSavedFiltersStore()
    const tableHooks = useTableHooksFromStore(load, {}, true, store)

    return (
        <>
            <ProductsTable
                tableHooks={tableHooks}
                store={store}
                savedFiltersStore={savedFiltersStore}
            />
        </>
    )
})
